import apiClient from './apiClient';

export const authApi = {
    login: (username, password) => apiClient.post('/api/auth/login', { username, password }).then(res => res.data),
    changeRequiredPassword: (password) => apiClient.put('/api/auth/change-required-password', { password }).then(res => res.data),
    getMyTools: () => apiClient.get('/api/auth/my-tools').then(res => res.data),
};
